module.exports = "  <div :class=\"className\">\r\n    <wc-icon v-if=\"showIcon\" class=\"icon\" :name=\"iconName\"></wc-icon>\r\n    <span class=\"message\">{{message}}</span>\r\n    <span class=\"description\">{{description}}<slot></slot></span>\r\n  </div>"


//////////////////
// WEBPACK FOOTER
// ./~/wc-lib/src/wc-ui/components/alert/alert.html
// module id = 406
// module chunks = 0